import React from "react"
import { Link } from "gatsby"
import classNames from "classnames"

const SiteHeader = ({ location }) => {
  let path = ""
  if (location && location.pathname) path = location.pathname
  return (
    <header className="body">
      <div className="flex justify-end">
        <nav className="flex justify-end">
          <div className="mr-4">
            <Link
              className={classNames({
                link: true,
                "link--active": !!path.match(/^\/$/g),
              })}
              to="/"
            >
              Home
            </Link>
          </div>
          <div className="mr-4">
            <Link
              className={classNames({
                link: true,
                "link--active": !!path.match(/\/about(.*)$/g),
              })}
              to="/about"
            >
              About
            </Link>
          </div>
          <div className="mr-4">
            <Link
              className={classNames({
                link: true,
                "link--active": !!path.match(/\/posts(.*)$/g),
              })}
              to="/posts"
            >
              Thought
            </Link>
          </div>
          <div className="mr-4">
            <Link
              className={classNames({
                link: true,
                "link--active": !!path.match(/\/works(.*)$/g),
              })}
              to="/works"
            >
              Work
            </Link>
          </div>
          <div>
            <a
              className="link button"
              href="mailto:max8hine@gmail.com?subject=Let's catch up&body=Hi Max,%0D%0A"
            >
              Talk
            </a>
          </div>
        </nav>
      </div>
    </header>
  )
}

export default SiteHeader
